export default __webpack_public_path__ + "static/media/pencil.557f843e.jpg";